/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DeviceHubOutputMethods } from "./DeviceHubOutputMethods";
import {
    DeviceHubOutputMethodsFromJSON,
    DeviceHubOutputMethodsFromJSONTyped,
    DeviceHubOutputMethodsToJSON,
} from "./DeviceHubOutputMethods";
import type { DeviceHubInputMethods } from "./DeviceHubInputMethods";
import {
    DeviceHubInputMethodsFromJSON,
    DeviceHubInputMethodsFromJSONTyped,
    DeviceHubInputMethodsToJSON,
} from "./DeviceHubInputMethods";

/**
 *
 * @export
 * @interface DeviceHubDocumentationResponse
 */
export interface DeviceHubDocumentationResponse {
    /**
     *
     * @type {DeviceHubInputMethods}
     * @memberof DeviceHubDocumentationResponse
     */
    inputMethods?: DeviceHubInputMethods;
    /**
     *
     * @type {DeviceHubOutputMethods}
     * @memberof DeviceHubDocumentationResponse
     */
    outputMethods?: DeviceHubOutputMethods;
}

/**
 * Check if a given object implements the DeviceHubDocumentationResponse interface.
 */
export function instanceOfDeviceHubDocumentationResponse(
    value: object,
): value is DeviceHubDocumentationResponse {
    return true;
}

export function DeviceHubDocumentationResponseFromJSON(
    json: any,
): DeviceHubDocumentationResponse {
    return DeviceHubDocumentationResponseFromJSONTyped(json, false);
}

export function DeviceHubDocumentationResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceHubDocumentationResponse {
    if (json == null) {
        return json;
    }
    return {
        inputMethods:
            json["inputMethods"] == null
                ? undefined
                : DeviceHubInputMethodsFromJSON(json["inputMethods"]),
        outputMethods:
            json["outputMethods"] == null
                ? undefined
                : DeviceHubOutputMethodsFromJSON(json["outputMethods"]),
    };
}

export function DeviceHubDocumentationResponseToJSON(
    value?: DeviceHubDocumentationResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        inputMethods: DeviceHubInputMethodsToJSON(value["inputMethods"]),
        outputMethods: DeviceHubOutputMethodsToJSON(value["outputMethods"]),
    };
}
